import React from 'react'
import { makeStyles } from '@material-ui/styles'
import { Grid, Typography } from '@material-ui/core'
import { Helmet } from 'react-helmet'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(4),
  },
  content: {
    paddingTop: 150,
    textAlign: 'center',
  },
  image: {
    marginTop: 50,
    display: 'inline-block',
    maxWidth: '100%',
    width: 560,
  },
}))

const NotFound = () => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <Helmet>
        <title>404 | Всички стаи</title>
      </Helmet>
      <Grid container justifyContent="center" spacing={4}>
        <Grid item lg={6} xs={12}>
          <div className={classes.content}>
            <Typography variant="h1">Страницата, която търсиш не съществува</Typography>
            <Typography variant="subtitle2">
              Знаем, че си ескейп ентусиаст и все пак ще намериш каквото търсиш, но ще трябва да се
              справиш без нашата помощ :(
            </Typography>
            <img
              alt="Not found"
              className={classes.image}
              src="/image/undraw_page_not_found_su7k.svg"
            />
          </div>
        </Grid>
      </Grid>
    </div>
  )
}

export default NotFound
